import { Component, type ReactNode } from 'react';

interface Props { children: ReactNode; }
interface State { hasError: boolean; error: string; }

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: '' };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error: error.message };
  }

  componentDidCatch(error: Error, info: any) {
    console.error('[ZIKO ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', background: '#0a0a0f', color: '#e5e7eb',
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', fontFamily: 'Inter, sans-serif', padding: '24px', textAlign: 'center'
        }}>
          <img src="/favicon.png" alt="ZIKO" style={{ width: 56, height: 56, borderRadius: '50%', marginBottom: 20 }} />
          <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Something went wrong 😔</h2>
          <p style={{ fontSize: 14, color: '#9ca3af', marginBottom: 24, maxWidth: 320 }}>
            Don't worry — your cart and orders are safe. Please refresh the page to continue shopping.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 28px', background: '#3b82f6', color: '#fff',
              border: 'none', borderRadius: 12, fontWeight: 700, fontSize: 14,
              cursor: 'pointer', marginBottom: 12
            }}
          >
            Refresh Page
          </button>
          <a href="/" style={{ fontSize: 13, color: '#6b7280' }}>← Back to homepage</a>
        </div>
      );
    }
    return this.props.children;
  }
}
